import { InsurancePolicyDetails } from './InsurancePolicyDetailsSubform.types';

interface InsurancePolicyIntegrationFieldSource {
  deathBenefitAmount?: unknown;
  cashValue?: unknown;
  policyNumber?: string | null;
  policyType?: InsurancePolicyDetails['policyType'] | null;
  premiumAmount?: unknown;
  policyStartDate?: unknown;
  termLength?: InsurancePolicyDetails['termLength'] | null;
}

export function getInsurancePolicyIntegrationPrefilledFields(
  policy: InsurancePolicyIntegrationFieldSource
): Set<keyof InsurancePolicyDetails> {
  const fields = new Set<keyof InsurancePolicyDetails>();

  if (policy.deathBenefitAmount != null) fields.add('deathBenefitAmount');
  if (policy.cashValue != null) {
    fields.add('cashValue');
    fields.add('cashValueDate');
  }
  if (policy.policyNumber) fields.add('policyNumber');
  if (policy.policyType) fields.add('policyType');
  if (policy.premiumAmount != null) fields.add('premiumAmount');
  if (policy.policyStartDate != null) fields.add('policyStartDate');
  if (policy.termLength !== '' && policy.termLength != null) {
    fields.add('termLength');
  }

  return fields;
}
